import { render, staticRenderFns } from "./icon-tel.vue?vue&type=template&id=07138bdf&scoped=true"
import script from "./icon-tel.vue?vue&type=script&lang=js"
export * from "./icon-tel.vue?vue&type=script&lang=js"
import style0 from "./icon-tel.vue?vue&type=style&index=0&id=07138bdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07138bdf",
  null
  
)

export default component.exports